import { TimeTransferStatus } from '@data-terminal/shared-models/dialogs/sign-off-dialog';
import { SnackbarClass } from '@data-terminal/shared-models/global';
import { SnackBarService } from '@data-terminal/utils/services';
import { TranslateService } from '@ngx-translate/core';

export function notifyOnTimeTransferStatusChange(
    status: TimeTransferStatus,
    lastNotifiedStatus: TimeTransferStatus,
    snackBarService: SnackBarService,
    translate: TranslateService,
    allowErrorSnackbar = false
): TimeTransferStatus {
    if (status === TimeTransferStatus.DONE && lastNotifiedStatus !== TimeTransferStatus.DONE) {
        snackBarService.openSnackBar(
            translate.instant('DC.SIGN_OFF_DIALOG.TIME_TRANSFER.SNACKBAR.SUCCESS'),
            SnackbarClass.SUCCESS
        );
        return TimeTransferStatus.DONE;
    }

    if (status === TimeTransferStatus.ERROR && lastNotifiedStatus !== TimeTransferStatus.ERROR && allowErrorSnackbar) {
        snackBarService.openSnackBar(translate.instant('DC.SIGN_OFF_DIALOG.TIME_TRANSFER.ERROR'), SnackbarClass.ERROR);
        return TimeTransferStatus.ERROR;
    }

    if (status === TimeTransferStatus.TRANSFERRING) {
        return TimeTransferStatus.TRANSFERRING;
    }

    return lastNotifiedStatus;
}
